import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/index'
import Error404 from './pages/404'
import TermsOfService from './pages/utility/terms'
import PrivacyPolicy from './pages/utility/privacy-policy'
import CookiePolicy from './pages/utility/cookie-policy'
import Fixtures from './pages/fixtures'
import Support from './pages/utility/support'
import BettingTips from './pages/betting-tips'
import Premium from './pages/premium'
import DashboardStatistics from './pages/profile/dashboard/index'
import AccountSecurity from './pages/profile/change-password'
import PlansPricing from './pages/profile/pricing-plans'
import Billing from './pages/profile/billing'
import Profile from './pages/profile/profile'
import Notifications from './pages/profile/notifications'
import MyPredictions from './pages/profile/my-predictions'
import PredictionsPreview from './pages/predictions'
import { useDispatch, useSelector } from 'react-redux'
import CompetitionServiceInstance from './services/CompetitionService'
import { setCoverageCompetitions, setMarkets, setPlans } from './store/slices/UtilitySlice'
import { setFavouriteCompetitions } from './store/slices/MemberSlice'
import { isValidValue } from './helpers/FormHelper'
import Match from './pages/match'
import UtilityServiceInstance from './services/UtilityService'


export default function MainRouter() {
	const token = useSelector((state) => state.Auth.token);
	const markets = useSelector((state) => state.Utility.markets);
	const subscriptionPlans = useSelector((state) => state.Utility.plans);
	const coveredLeagues = useSelector((state) => state.Utility.coverageCompetitions);
	const dispatch = useDispatch();

	useEffect(() => {
		const hasCoveredLeagues = coveredLeagues?.length > 0;
		if (hasCoveredLeagues === true) return

		const fetchCoveredLeagues = async () => {
			try {
				const response = await CompetitionServiceInstance.getCoveredLeagues();
				const responseData = response.data;
				const { success, result } = responseData;
				if (success === true) {
					dispatch(setCoverageCompetitions(result.data));
				}
			} catch (error) {

			}
		};

		fetchCoveredLeagues();
	}, []);

	useEffect(() => {
		const hasSubscriptionPlans = subscriptionPlans?.length > 0;
		if (hasSubscriptionPlans === true) return

		const fetchSubscriptionPlans = async () => {
			try {
				const response = await UtilityServiceInstance.getSubscriptionPlans();
				const responseData = response.data;
				const { success, result } = responseData;
				if (success === true) {
					dispatch(setPlans(result.data));
				}
			} catch (error) {

			}
		};

		fetchSubscriptionPlans();
	}, []);

	useEffect(() => {
		const hasMarkets = markets?.length > 0;
		if (hasMarkets === true) return

		const fetchMarkets = async () => {
			try {
				const response = await UtilityServiceInstance.getMarkets();
				const responseData = response.data;
				const { success, result } = responseData;
				if (success === true) {
					dispatch(setMarkets(result.data));
				}
			} catch (error) {

			}
		};

		fetchMarkets();
	}, []);

	useEffect(() => {
		const isValidToken = isValidValue(token);
		if (isValidToken === false) return

		const fetchFavouriteLeagues = async () => {
			try {
				const response = await CompetitionServiceInstance.getFavouriteLeagues(token);
				const responseData = response.data;
				const { success, result } = responseData;
				if (success === true) {
					dispatch(setFavouriteCompetitions(result?.data?.map((item) => item?.competition)));
				}
			} catch (error) {

			}
		};

		fetchFavouriteLeagues();
	}, []);

	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/home" element={<Home />} />
					<Route path="/fixtures" element={<Fixtures />} />
					<Route path="/match/:id" element={<Match />} />
					<Route path="/tips" element={<BettingTips />} />
					<Route path="/premium" element={<Premium />} />
					<Route path='/terms' element={<TermsOfService />} />
					<Route path='/privacy' element={<PrivacyPolicy />} />
					<Route path='/cookies' element={<CookiePolicy />} />
					<Route path='/support' element={<Support />} />
					<Route path='/faq' element={<Support />} />
					<Route path='/contact' element={<Support />} />
					<Route path='/dashboard' element={<DashboardStatistics />} />
					<Route path='/predictions' element={<PredictionsPreview />} />
					<Route path='/my/predictions' element={<MyPredictions />} />
					<Route path='/notifications' element={<Notifications />} />
					<Route path='/account/profile' element={<Profile />} />
					<Route path='/account/billing' element={<Billing />} />
					<Route path='/plans' element={<PlansPricing />} />
					<Route path='/account/security' element={<AccountSecurity />} />
					<Route path='/cookies/preferences' element={<Error404 />} />
					<Route path="/404" element={<Error404 />} />
				</Routes>
			</BrowserRouter>
		</>
	)
}
